
    import __i18nConfig from '@next-translate-root/i18n'
    import __loadNamespaces from 'next-translate/loadNamespaces'
    import Head from "next/head";
import React, { useContext, useState } from "react";
import Layout from "../components/Layout";
import { SearchProvider, getInitialStateFromQuery, queryParamsToApiInputVariables } from "../components/search/SearchContext";
import useTranslation from "next-translate/useTranslation";
import { Dog, CountryServiceType, InferredCountryServiceType } from "../interfaces";
import SearchPage from "../components/search/SearchPage";
import { Box, Flex } from "rebass/styled-components";
import OtherCities from "../components/sitterprofile/OtherCities";
import BreadcrumbList from "../components/common/BreadcrumbList";
import { LocaleContext } from "../components/locale";
import { MetaContext } from "../components/meta";
import HowItWorks from "../components/sitterprofile/HowItWorks";
import { Benefits } from "../components/sitterprofile/Contact";
import { trackOwnerSitterSearched } from "../lib/event-tracking";
import canonical from "../lib/canonical";
import { GetServerSideProps } from "next";
import { addApolloState, initializeApollo } from "../lib/apolloClient";
import { useRouter } from "next/router";
import { GetCountryAndCurrentUserDocument, SearchDocument, useGetCountryAndCurrentUserQuery, useSearchQuery } from "../generated/graphql";
import { useIsMobile, withDeviceType } from "../lib/media";
interface Props {
    query: Record<string, any>;
    countryServiceTypes: CountryServiceType[];
    userDogs: Dog[];
    deviceType?: string;
}
function SearchSomething(props: Props) {
    const { searchInputVariables } = props;
    const { t } = useTranslation("search");
    const [mobileMapVisible, setMobileMapVisible] = useState(false);
    const isMobileViewport = useIsMobile(props.deviceType);
    const { loading, error, data, fetchMore } = useSearchQuery({
        variables: searchInputVariables,
        onCompleted: data => {
            trackOwnerSitterSearched(searchInputVariables, data.search, !!data.search?.caregivers[0]?.bookingEstimation);
        }
    });
    const searchResults = loading ? null : data && data.search;
    return (<Box>
      <SearchPage searchResults={searchResults} loading={loading} error={error} fetchMore={fetchMore} h1Heading={t("h1Heading")} h2Heading={t("h2Heading", {
            sittersCount: searchResults?.totalEntries || "..."
        })} isMobileViewport={isMobileViewport} mobileMapVisible={mobileMapVisible} setMobileMapVisible={setMobileMapVisible} breadcrumb={<BreadcrumbList breadcrumbs={[
                {
                    name: t("gudog"),
                    href: "/",
                    position: "2"
                }
            ]} activeItem={{
                name: t("dogSitters"),
                href: "/search",
                position: "2"
            }}/>} {...props}/>
      {searchResults && !mobileMapVisible && (<Box variant="layout.large" pb={5}>
          <Flex mt={[1, 7]} pt={[3, 6]} pb={[2, 5]} px={[1, 0]} sx={{
                borderTop: "default",
                borderBottom: "default",
            }} flexDirection={["column", "row"]}>
            <Box width={["100%", "50%"]} mr={[0, 8]} mb={[3, 0]}>
              <HowItWorks />
            </Box>

            <Box width={["100%", "50%"]}>
              <Benefits />
            </Box>
          </Flex>

          <OtherCities serviceType={searchResults.serviceType} topCities={searchResults.topCities} city={searchResults.city}/>
        </Box>)}
    </Box>);
}
function Search(props: Props) {
    const { query } = useRouter();
    const searchInputVariables = queryParamsToApiInputVariables(query);
    const { t } = useTranslation("search");
    const { locale } = useContext(LocaleContext);
    const { url } = useContext(MetaContext);
    const { data: queryData } = useGetCountryAndCurrentUserQuery();
    const countryServiceTypes: InferredCountryServiceType[] = (queryData && queryData.country?.countryServiceTypes) || [];
    const userDogs = queryData && queryData.currentUser ? queryData.currentUser.dogs : [];
    const initialSearchContextState = countryServiceTypes
        ? getInitialStateFromQuery(searchInputVariables, countryServiceTypes)
        : null;
    const params = {
        ...query,
        locale: locale
    };
    const queryString = Object.keys(params)
        .map(key => key + "=" + params[key])
        .join("&");
    return (<Layout title={t("search:title")} description={t("search:description")} displayFooterAreas withHrefLang>
      <Head>
        <meta property="al:ios:url" content={`gudog://search/?${queryString}`}/>
        <meta property="al:android:url" content={`gudog://search/?${queryString}`}/>
        <link rel="canonical" href={canonical(url)}/>
      </Head>

      {initialSearchContextState && (<SearchProvider initialStateFromQuery={initialSearchContextState}>
          <SearchSomething countryServiceTypes={countryServiceTypes} userDogs={userDogs} searchInputVariables={searchInputVariables} {...props}/>
        </SearchProvider>)}
    </Layout>);
}
const getServerSideProps: GetServerSideProps = withDeviceType()(async (context) => {
    const { query, locale, req } = context;
    const apolloClient = initializeApollo(locale!, req);
    await Promise.all([
        apolloClient.query({
            query: SearchDocument,
            variables: queryParamsToApiInputVariables(query)
        }),
        apolloClient.query({ query: GetCountryAndCurrentUserDocument })
    ]);
    return addApolloState(apolloClient, {
        props: {
            locale
        }
    });
});
export default Search;

    async function __Next_Translate__getServerSideProps__1980d144565__(ctx) {
      const res = await getServerSideProps(ctx)
      return {
        
        ...res,
        props: {
          ...(res.props || {}),
          ...(await __loadNamespaces({
            ...ctx,
            ...__i18nConfig,
            pathname: '/search',
            loaderName: 'getServerSideProps',
            loadLocaleFrom: __i18nConfig && __i18nConfig.loadLocaleFrom || ((l, n) => import(`@next-translate-root/locales/${l}/${n}`).then(m => m.default)),
          }))
        }
      }
    }
    export { __Next_Translate__getServerSideProps__1980d144565__ as getServerSideProps }
  